@use '~@frontrow/console/css/variables.scss';

.panelListSorterContainer {
  display: flex;
  align-items: center;
  font-size: variables.$font-size-sm;
}

.panelListSorterDescription {
  margin-right: variables.$std-margin-md;
}

.panelListSorterElement {
  margin-bottom: 0;
  border: none;
  padding: 0;
}

.panelListSorterLegend {
  font-weight: bold;
  font-size: variables.$font-size-sm;
  padding: 0;
  margin-right: variables.$std-margin-md;
  float: left;
}

.radioInline {
  display: inline-flex;
  align-items: center;
  margin-right: 1rem;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }
}

.radioInput {
  margin-right: 0.5rem;
  cursor: pointer;
}
